<template>
    <div id="app">
        <v-app id="inspire">
            <v-layout wrap>
                <v-toolbar flat class="mt-5 elevation-1 hidden-md-and-up ma-0 pa-0 pt-0 title deep-orange  font-weight-regular white--text" @click="(useCurrentLoc(),attemp=1)">Use my current location <v-spacer></v-spacer><v-icon class="white--text">my_location</v-icon> 
                </v-toolbar>

                <v-flex>
                    <v-text-field class="font-weight-regular ma-0 pa-0 hidden-md-and-up" v-model="formattedAddress" :hide-details="true" solo label="Enter Place or Branch" append-icon="search" @click:append="(geoCoding())" @keyup.enter="(geoCoding())"></v-text-field>
                </v-flex>

                <v-carousel v-if="gallery.length > 0" hide-controls height="600" class="hidden-sm-and-down">
                    <v-carousel-item v-for="(item,i) in gallery" :key="i" :src="item.url"></v-carousel-item>
                </v-carousel>

                <v-carousel v-if="gallery.length > 0" hide-controls height="400" class="hidden-md-and-up">
                    <v-carousel-item v-for="(item,i) in gallery" :key="i" :src="item.url"></v-carousel-item>
                </v-carousel>

                <v-dialog content-class="mapDialog  hidden-sm-and-down" :value="true" width="400" height="100" hide-overlay persistent> 
                    <v-card-title class="title deep-orange  font-weight-regular white--text" @click="(useCurrentLoc(),attemp=1)">
                    <v-icon class="white--text">my_location</v-icon> Use my current location
                    </v-card-title>
            
                    <v-flex>
                        <v-text-field class="font-weight-regular" :hide-details="true" v-model="formattedAddress" solo label="Enter Place or Branch" append-icon="search" @click:append="geoCoding()" @keyup.enter="geoCoding()" height=60 ></v-text-field>
                    </v-flex>
                </v-dialog>

                <v-dialog :value="true" content-class="detailsDialog hidden-sm-and-down" width="400px" height="100px" hide-overlay persistent>  
                    <v-toolbar class="subheading deep-orange  font-weight-regular" dense>
                    <v-toolbar-title class="subheading deep-orange  font-weight-regular white--text">Branch Information</v-toolbar-title>
                    </v-toolbar>
                    <v-list style="max-height:330px; overflow-y: auto;" content-class="listInfo" three-line subheader expand light>
                        <template v-for="(list, index) in sortBranches">
                            <v-list-tile :key="index">
                                <v-list-tile-content>
                                    <v-list-tile-title >{{ list.businessUnit }}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ list.address }}</v-list-tile-sub-title>
                                    <v-list-tile-sub-title>Distance : {{ list.distance.toFixed(2) }} km</v-list-tile-sub-title>
                                </v-list-tile-content>

                                <v-list-tile-action class="caption font-weight-regular">
                                    <div v-if="user==null">
                                        <div v-if="list.status==true">
                                            <v-btn flat color="primary" @click="(checkBranchAccess(list))">Book</v-btn>
                                        </div>     
                                    </div>

                                    <div v-else>
                                        <div v-if="list.status==true">
                                            <v-btn flat color="primary" @click="(checkBranchAccess(list))">Book</v-btn>
                                        </div>     
                                    </div>
                                </v-list-tile-action>
                            </v-list-tile>
                        <v-divider v-if="index + 1 < sortBranches.length" :key="list.branchCode"></v-divider>
                        </template>
                    </v-list>
                </v-dialog>

                
                <GmapMap v-if="gallery.length < 1" :center="{lat: mapLat, lng: mapLng}" :zoom="13" class="hidden-sm-and-down"
                    map-type-id="roadmap" style="width: 100%; height: 700px"
                    :options="{zoomControl: true, mapTypeControl: false, scaleControl: false, streetViewControl: false, rotateControl: false, fullscreenControl: true, disableDefaultUi: true}">

                    <v-menu offset-x>
                        <template v-slot:activator="{ on }">
                            <gmap-marker
                                v-for="(list,index) in businessUnits" :key="index"
                                :position="google && new google.maps.LatLng(list.latitude, list.longitude)" :clickable="true"
                                :label="list.businessUnit"
                                @click="(center=google && new google.maps.LatLng(list.latitude, list.longitude))" icon="https://img.icons8.com/color/48/000000/marker.png"
                            ></gmap-marker>
                        </template>
                    </v-menu>
                </GmapMap>

                <GmapMap v-if="gallery.length < 1" :center="{lat: mapLat, lng: mapLng}" :zoom="11" class="hidden-md-and-up"
                    map-type-id="roadmap" style="width: 100%; height: 300px"
                    :options="{zoomControl: true, mapTypeControl: false, scaleControl: false, streetViewControl: false, rotateControl: false, fullscreenControl: true, disableDefaultUi: true}">

                    <v-menu offset-x>
                        <template v-slot:activator="{ on }">
                            <gmap-marker
                                v-for="(list,index) in businessUnits" :key="index"
                                :position="google && new google.maps.LatLng(list.latitude, list.longitude)" :clickable="true"
                                @click="(center=google && new google.maps.LatLng(list.latitude, list.longitude))" icon="https://img.icons8.com/color/48/000000/marker.png"
                                :label="list.BusinessUnit"
                            ></gmap-marker>
                        </template>
                    </v-menu>
                </GmapMap>
            </v-layout>

            <v-layout class="hidden-md-and-up">
                <v-flex xs12>
                <v-toolbar class="subheading deep-orange  font-weight-regular" dense>
                <v-toolbar-title class="subheading deep-orange  font-weight-regular white--text">Branch Information</v-toolbar-title>
                </v-toolbar>
                </v-flex>
            </v-layout>
            
            <v-layout class="hidden-md-and-up">
                <v-flex xs12>
                    <v-list style="max-height:330px; overflow-y: auto;" content-class="listInfo" three-line subheader expand light>
                        <template v-for="(list, index) in sortBranches">
                            <v-list-tile :key="index">
                                <v-list-tile-content>
                                    <v-list-tile-title >{{ list.businessUnit }}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ list.address }}</v-list-tile-sub-title>
                                    <v-list-tile-sub-title>Distance : {{ list.distance.toFixed(2) }} km</v-list-tile-sub-title>
                                </v-list-tile-content>

                                <v-list-tile-action class="caption font-weight-regular">
                                    <div v-if="user==null">
                                        <div v-if="list.status==true">
                                            <v-btn flat color="primary" @click="(checkBranchAccess(list))">Book</v-btn>
                                        </div>     
                                    </div>

                                    <div v-else>
                                        <div v-if="list.status==true">
                                            <v-btn flat color="primary" @click="(checkBranchAccess(list))">Book</v-btn>
                                        </div>     
                                    </div>
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-divider v-if="index + 1 < sortBranches.length" :key="list.branchCode"></v-divider>
                        </template>
                    </v-list>
                </v-flex>
            </v-layout>
            <!-- <v-dialog v-model="updateInfoDialog" persistent max-width="800px">
                <profile-component></profile-component>
            </v-dialog> -->
            <profileComponent v-model="profileComponent.show" />
            <Snackbar v-model="snackbar.show" :type="snackbar.type" :message="snackbar.message" />
            <Progress v-model="progress.show" :message="progress.message" />
        </v-app>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import {db} from '../main'
import { gmapApi } from "vue2-google-maps"
import geolocation from 'vue-geolocation-api'
import profileComponent from './Profile.vue'
import Progress from './Progress.vue'
import Snackbar from './Snackbar.vue'

export default {
    components: {
        profileComponent,
        Progress,
        Snackbar,
    },
    data() {
        return {
            preferredLoc: this.$route.params.preferredLoc,
            formattedAddress: this.$route.params.preferredLoc,
            businessUnits: [],
            nearestbranch: {},
            sortBranches: [],
            currentPosition: {
                lat: this.$route.params.lat,
                lng: this.$route.params.lng,
            },
            mapLat: 0,
            mapLng: 0,
            branchWithAccess: [],
            alertColor: "",
            attemp: 0,
            gallery: [],
            profileComponent: {
                show: false,
            },
            progress: {
                message: "",
                show: false,
            },
            snackbar: {
                responseMessage: "",
                show: false,
                type: "success"
            },
        }
    },

    methods : {
        showProgress(message) {
            this.progress.message = message
            this.progress.show = true
        },
        stopProgress() {
            this.progress.show = false
        },
        showSnackbarMessage(message, success = true) {
            this.snackbar.type = success ? "success" : "error"
            this.snackbar.message = message
            this.snackbar.show = true
        },
        // ********* FETCH ALL BRANCHES *************
        async fetchBranches() {
            let self = this 
            let branches = []
            await db.collection("Branches"+self.$stage)
                .get().then(function(querySnapshots) {
                    querySnapshots.forEach(function(doc) {
                        if (doc.data().latitude !== "" && doc.data().longitude !== ""){
                            branches.push(doc.data())
                        }
                    })
                }).then(function(){
                    self.businessUnits = []
                    for(let i = 0; i < branches.length; i++){
                        let branch = branches[i]
                        let distance = getDistanceFromLatLonInKm({
                            latitude: self.currentPosition.lat,
                            longitude: self.currentPosition.lng
                        },
                        {
                            Latitude: branch.latitude,
                            Longitude: branch.longitude
                        })
                        branch.distance = distance
                        if (!isNaN(branch.distance)) {
                            self.businessUnits.push(branch)  
                        }
                    }
                    self.businessUnits = _.uniqBy(self.businessUnits, 'branchCode')
                    self.sortToNearest() 
                    self.stopProgress()
                }).catch(error => {console.log(error)})
        },

        // ********* CHECK BRANCH ACCESS *******************
        checkBranchAccess(check) {
            let self = this
            let mechanics = []
            let count = 0
            self.branchWithAccess = []

            db.collection("Mechanics"+self.$stage)
            .where("branchId","==",check.id)
            .where("tag","==",true)
            .where("status","==","Active")
            .get().then(function(snapshot) {
                snapshot.forEach(function(doc) {
                    mechanics.push(doc)
                })
            }).then(function() {
                if (mechanics.length > 0) {
                    if (self.user) {
                        self.goToPage(`service-scheduler/${check.businessUnit}/${check.branchCode}/${check.id}/2`)
                    } else {
                        localStorage.setItem("redirect", `${window.location.origin}/service-scheduler/${check.businessUnit}/${check.branchCode}/${check.id}/2`);
                        self.$router.push(`/service-scheduler/${check.businessUnit}/${check.branchCode}/${check.id}/2`)
                    }
                    
                } else {
                    self.showSnackbarMessage(check.businessUnit + " is not yet available for service scheduler application. You can visit us at store.", false)   
                }
            })  
        },

        // ********* COMPUTATION OF LAT & LANG *************
        closestLocation(targetLocation, locationData) {
            return locationData.reduce(function(prev, curr) {
                let prevDistance = locationDistance(targetLocation, prev),
                    currDistance = locationDistance(targetLocation, curr)
                return (prevDistance < currDistance) ? prev : curr
            })
        },

        // ********* ARRANGEMENT OF LIST OF BRANCHES FROM NEAREST *************
        sortToNearest() {
            let self = this
            self.sortBranches = _.sortBy(self.businessUnits, ['distance'])
        },
        
        // ********* CONVERT INPUTED LOCATION TO COORDINATES *************
        geoCoding() {
            let self = this
            let geoCoordinates = []
            // self.showProgress("Loading..") 
            let url = "https://maps.googleapis.com/maps/api/geocode/json?address="+self.formattedAddress+"&key=AIzaSyDHAjcezNBpAbyyj9PwSnH5fplYE1o9cOE"
            let instance = self.$axios.create()
            instance.defaults.headers.common = {}

            if (self.formattedAddress !== "") {
                self.sortBranches = []
                self.$axios.get(url).then(result => {
                    if(self.currentPosition) {
                            result.data.results.forEach(function(doc){
                            geoCoordinates.push(doc.geometry)
                        })
                        self.currentPosition.lat = geoCoordinates[0].location.lat,
                        self.currentPosition.lng = geoCoordinates[0].location.lng
                        setTimeout(() => {
                            self.fetchBranches()
                        }, 100)                  
                    } else {
                        self.showSnackbarMessage("Please allow your location to proceed.", false)   
                    }
                })
            } else {
                self.showSnackbarMessage("Please input preferred location.", false) 
            }
        },

        // ********* FETCH CURRENT LOCATION *************
        useCurrentLoc() {
            let self = this
            self.showProgress("Loading...") 
            let currentAddress = []
            let encodeUrl = encodeURI(self.formattedAddress)
            let url ="https://us-central1-servicescheduler-af9f2.cloudfunctions.net/reverse_geocoder" 
            self.$geolocation.getCurrentPosition().then(result => {
                if (result.coords) {
                    self.currentPosition = {
                        lat: result.coords.latitude,
                        lng: result.coords.longitude,
                    }
                    let body = {
                        'lat': self.currentPosition.lat,
                        'lng': self.currentPosition.lng
                    }  
                    self.mapLat = self.currentPosition.lat
                    self.mapLng = self.currentPosition.lng
                    self.$axios.post(url,body).then(result => {
                        result.data.forEach(function(doc){
                            currentAddress.push(doc.formatted_address)
                        })
                    }).then(function(){
                        self.formattedAddress = currentAddress[0]
                        self.fetchBranches()
                    })  
                }
            }).catch(function(error) {
                if (error.code == error.PERMISSION_DENIED) {
                    self.currentPosition = null
                    if (self.attemp === 1 && self.currentPosition === null) {
                        self.showSnackbarMessage("Please allow your location to proceed.", false)   
                    }
                }
            })
        },

        async fetchSlides() {
            let self = this
            self.gallery = []
            await db.collection("Slides_dev")
            .get().then(function(querySnapshots) {
                querySnapshots.forEach(function(doc) {
                    if (doc.data().tag == "Branch" && doc.data().active == true && doc.data().url != "") {
                        self.gallery.push(doc.data())
                    }
                })
            }).then(function() {
                if (self.preferredLoc) {
                    self.geoCoding()
                } else {
                    self.useCurrentLoc()
                }
            }).catch(function(error){
                console.log(error)
            })
        },

        // ********* R O U T E ***********
        goToPage(page) {
            this.$router.push("/"+page)
        },

    },

    mounted() {
        let self = this
        self.fetchSlides()
        if (self.Auth.profileComponent == "1") {
            self.profileComponent.show = true
            console.log("show profile component")
            console.log(self.profileComponent.show)
        } 
    },

    computed: {
        google: gmapApi,
        ...mapGetters(["user"]),
        ...mapState(["Auth"]),
    },

    watch: {
        businessUnits(newValue) {
            this.nearestbranch = this.closestLocation({ latitude: this.currentPosition.lat, longitude: this.currentPosition.lng }, newValue)
            this.mapLat = parseFloat(this.nearestbranch.latitude)
            this.mapLng = parseFloat(this.nearestbranch.longitude)
        },

        currentPosition: {
            handler: function(newValue) {
                try {
                    this.nearestbranch = this.closestLocation({ latitude: this.currentPosition.lat, longitude: this.currentPosition.lng }, this.businessUnits)
                    this.mapLat = parseFloat(this.nearestbranch.latitude)
                    this.mapLng = parseFloat(this.nearestbranch.longitude)
                } catch (error) {}   
            },
            deep: true
        },

        // Auth: {
        //    handler: function(newValue) {
        //         let self = this
        //         if (self.Auth.profileComponent == "1") {
        //             self.updateInfoDialog = true
        //         } else if  (self.Auth.profileComponent == "0") {
        //             self.updateInfoDialog = false
        //         }
        //    },
        //    deep: true
        // },
    }
}

function vectorDistance(dx, dy) {
    return Math.sqrt(dx * dx + dy * dy)
}

function locationDistance(location1, location2) {
    let dx = location1.latitude - location2.latitude,
        dy = location1.longitude - location2.longitude
    return vectorDistance(dx, dy)
}

// ********* GETTING THE KM DISTANCE PER BRANCH *************
function getDistanceFromLatLonInKm(location1, location2) {
    let R = 6371 // Radius of the earth in km
    let dLat = deg2rad(location2.Latitude-location1.latitude)  // deg2rad below
    let dLon = deg2rad(location2.Longitude-location1.longitude) 
    let a = 
        Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.cos(deg2rad(location1.latitude)) * Math.cos(deg2rad(location2.Latitude)) * 
        Math.sin(dLon/2) * Math.sin(dLon/2)
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
    let d = R * c // Distance in km
    return d
}

function deg2rad(deg) {
  return deg * (Math.PI/180)
}

</script>

<style>
    .mapDialog {
        position: absolute;
        top: 100px;
        left: 0px;
    }

    .detailsDialog {
        position: absolute;
        top: 240px;
        left: 0px;
    }

    #logo-container {
    	margin-right: 50px;
    }

    #logo-container img {
        height: 50px;
        width:auto;
        border-radius: 10%;
    }
    
    a {
    text-decoration: none;
    }

    .fit {
        max-width: 100%;
        max-height: 100%;
    }
    .gm-style-mtc {
        display: none;
    }
 
</style>
